import { createSlice } from "@reduxjs/toolkit";
import { fetchTimeslotData } from "../services/timeslot";

const initialState = {
  timeslotData: []
};

const timeslotSlice = createSlice({
  name: 'timeslot',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimeslotData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTimeslotData.fulfilled, (state, action) => {
        state.loading = false;
        state.timeslotData = action.payload;
      })
      .addCase(fetchTimeslotData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  }
});

export const timeslotReducer = timeslotSlice.reducer;